<div *ngIf="protestInfo" class="epds_mat_override">

  <mat-card>
    <mat-card-content>
      <div class="indent"></div>
      <table aria-label="Table with case information" role="presentation" fxFlex>
        <colgroup>
          <col style="width: 140px;">
          <col>
        </colgroup>
        <tbody>
        <tr>
          <td><span><strong>Protester</strong></span></td>
          <td><span>{{ protestInfo.company_Name }}</span></td>
        </tr>
        <tr>
          <td><span><strong>B-Number</strong></span></td>
          <td>
                <span [ngClass]="{ 'pending-entry color_warn': !protestInfo.b_No  }"
                      [matTooltip]="protestInfo.a_No">
                  {{ protestInfo.b_No || "pending" }}
                </span>
          </td>
        </tr>
        <tr>
          <td><span><strong>Agency</strong></span></td>
          <td><span>{{ protestInfo.agency_Name }}</span></td>
        </tr>
        <tr>
          <td><span><strong>Solicitation Number</strong></span></td>
          <td><span>{{ protestInfo.solicitation_No }}</span></td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>


  <form #protestForm="ngForm" (ngSubmit)="onSubmit(protestForm)">

      <mat-card>
        <mat-card-content fxLayout="column" fxLayoutAlign="start start" >

          @if (typeOfProtest === 'entitlement') {
            <div style="margin-bottom: 20px; padding: 10px; border: 1px solid gray;">
              Pursuant to 4 C.F.R. &#167; 21.8(e), if the agency decides to take corrective action
              in response to a protest, the protester may request that GAO recommend that the agency
              pay the protester the reasonable costs
              of filing and pursuing the protest,
              including attorneys&#8217; fees and consultant and expert witness fees.
            </div>
          }

          @if (typeOfProtest === 'cost-claim') {
            <div style="margin-bottom: 20px; padding: 10px; border: 1px solid gray;">
              Pursuant to 4 C.F.R. &#167; 21.8(f), if GAO recommends that the agency pay the protester
              the costs of filing and pursuing
              a protest and/or of bid or proposal preparation and the parties cannot reach agreement
              on the amount of costs,
              the protester may request that GAO recommend the amount of costs that the protester
              should be reimbursed.
            </div>

          }

          @if ((stateService.userRole === UserRole.GAO_Admin) && (typeOfProtest === 'reconsideration')) {
            <div fxFill>
              <div class="indent"></div>
              <div fxFlex>
              <mat-form-field appearance="outline" floatLabel="always" class="doc-select-width">
                <mat-label>Filer</mat-label>
                <mat-select placeholder="Please Select Filer"
                            name="selectedFiler"
                            (selectionChange)="onFilerChange($event)"
                            [(ngModel)]="selectedFiler" required>
                    <mat-option *ngFor="let option of requestForRecon" [value]="option">
                      {{ option.label }}
                    </mat-option>
                </mat-select>
              </mat-form-field>
              </div>
            </div>
          }

          @if ((stateService.userRole === UserRole.GAO_Admin) && (typeOfProtest === 'reconsideration') && selectedFiler && selectedFiler.label == 'INTERVENOR') {
            <div fxFill>
              <div class="indent"></div>
              <div fxFlex>
                <mat-form-field appearance="outline" floatLabel="always" class="doc-select-width">
                  <mat-label>Intervenor Company Name</mat-label>
                  <mat-select placeholder="Please Select Intervenor Company Name"
                              name="selectedIntervenorComp"
                              [(ngModel)]="selectedIntervenorComp" required>
                    <mat-option *ngFor="let option of intervenorCompNameList" [value]="option">
                      {{ option }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          }

          @if ((stateService.userRole === UserRole.GAO_Admin) && (typeOfProtest === 'reconsideration') && selectedFiler && selectedFiler.label === 'AGENCY') {
            <div fxFill>
              <div class="indent"></div>
              <div fxFlex>
                <mat-form-field appearance="outline" floatLabel="always" class="doc-select-width">
                  <mat-label>Agency Name</mat-label>
                  <mat-select placeholder="Please Select Agency Name"
                              name="selectedAgencyName"
                              [(ngModel)]="selectedAgencyName" required>
                    <mat-option *ngFor="let option of agencyNameList" [value]="option">
                      {{ option }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          }

          <!-- File Upload Component -->
          <mat-form-field floatLabel="always" appearance="outline" style="width: 100%">
            <mat-label> {{ primaryUploadText }} ( {{ uploadDocMessage }} )</mat-label>
            <input matInput style="display: none" />

            <app-file-upload #fileUpload
                             [fileUploadInProgress]="fileUploadInProgress"
                             [wrongFileTypeMessage]="uploadDocMessage"
                             [requiredFileType]="requiredFileType"
                             [primaryUploadText]="''"
                             (attachAssociatedDocOutput)="onAttachAssociatedDocOutput($event)"
                             (primaryEPDSFileListOutput)="onEPDSFileListChange($event, 'P')"
                             (associateEPDSFileListOutput)="onEPDSFileListChange($event, 'A')">
            </app-file-upload>
          </mat-form-field>

          <!-- Document Confidentiality -->
          <mat-form-field floatLabel="always" appearance="outline" style="width: 100%">
            <mat-label>Do any of these documents contain information that is proprietary, confidential, or otherwise not releasable to the public?</mat-label>
            <input matInput style="display: none" required/>

            <mat-radio-group [(ngModel)]="isDocConfidential"
                             name="isDocConfidential" required>
              <mat-radio-button value="Y">Yes</mat-radio-button>
              <mat-radio-button value="N">No</mat-radio-button>
            </mat-radio-group>
          </mat-form-field>

          <!-- Comments -->
          <mat-form-field appearance="outline" floatLabel="always" style="width: 100%">
            <mat-label>Comments</mat-label>
            <textarea matInput [(ngModel)]="comments" name="comments" rows="5" maxlength="250"></textarea>
            <mat-hint>{{ 250 - (comments ? comments.length : 0) }} characters remaining</mat-hint>
          </mat-form-field>


        </mat-card-content>
        <mat-card-actions fxLayout="row" fxLayoutAlign="center">
          <button mat-raised-button type="submit" color="primary" class="spinner-black"
                  [disabled]="fileUploadInProgress || saving || !protestForm.valid || ( primaryFiles.length === 0 ) || (attachAssociatedDocOutput && (associatedFiles.length === 0))" >
            <div *appSpinner="saving"></div>
            Submit
          </button>
        </mat-card-actions>
      </mat-card>

  </form>

</div>
